module.exports = [{"name":"香港","cityList":["中西区","东区","南区","湾仔区"]},{"name":"九龙半岛","cityList":["九龙城区","观塘区","深水埗区","黄大仙区","油尖旺区"]},{"name":"新界岛","cityList":["离岛区","葵青区","北区","西贡区","沙田区","大埔区","荃湾区","屯门区","元朗区"]}]


//////////////////
// WEBPACK FOOTER
// ./src/common/json/HONGKONG.json
// module id = +teN
// module chunks = 1